export default "__VITE_ASSET__DHtXsp8S__"